const API_URL = process.env.REACT_APP_api_url;
const API_BIZCOM_URL = process.env.REACT_APP_api_bizcom_url;

export const urlSendGetInTouch = API_URL+'/send-get-in-touch.php'
export const urlGeneralSendSystemEmail = API_BIZCOM_URL+'/general/send_system_email'
export const externalIPgeolocationDB = `https://geolocation-db.com/json/`